import React, { useEffect, useState, useRef } from "react";
import { TiTick } from "react-icons/ti";
import { db, functions } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore"; // Importuj potrzebne funkcje z Firebase
import { Button, ButtonGroup } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { formatWarehouse } from "../warehouseTime";
import History from "./History";
import { httpsCallable } from "firebase/functions";

export default function Stepper() {
  const [action, setAction] = useState("arrival");
  const [previousAction, setPreviousAction] = useState("arrival");
  const steps =
    action === "arrival"
      ? ["Action selection", "Site selection", "Data entry"]
      : action === "history"
      ? ["Action selection", "History"]
      : ["Action selection", "Data entry"];
  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [parkingType, setParkingType] = useState("Normal");
  const [previousParkingType, setPreviousParkingType] = useState("Normal");
  const [firstPlace, setFirstPlace] = useState();
  const [secondPlace, setSecondPlace] = useState();
  const [currentDate, setCurrentDate] = useState(
    formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss')
  );
  const registrationNumber = useRef();
  const firstContainerNumber = useRef();
  const secondContainerNumber = useRef();

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message);
    }
  };

  const openToast2 = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.success(message);
    }
  };

  const Step1 = () => {
    useEffect(() => {
      const btn_1 = document.querySelector(".btn-1");
      const btn_2 = document.querySelector(".btn-2");
      const btn_3 = document.querySelector(".btn-3");

      if (action === "arrival") {
        btn_1.classList.add("btn-active");
        btn_2.classList.remove("btn-active");
        btn_3.classList.remove("btn-active");
      } else if (action === "departure") {
        btn_2.classList.add("btn-active");
        btn_1.classList.remove("btn-active");
        btn_3.classList.remove("btn-active");
      } else if (action === "history") {
        btn_3.classList.add("btn-active");
        btn_1.classList.remove("btn-active");
        btn_2.classList.remove("btn-active");
      }
    }, [action]);

    return (
      <div className="flex flex-col w-full">
        <Button onClick={() => setAction("arrival")} className="button btn-1">
          Arrival
        </Button>
        <Button onClick={() => setAction("departure")} className="button btn-2">
          Departure
        </Button>
        <Button onClick={() => setAction("history")} className="button btn-3">
          History
        </Button>
      </div>
    );
  };

  const Step2 = () => {
    useEffect(() => {
      const buttonGroup = document.querySelectorAll("#btn-group")[0];
      if (buttonGroup) {
        Array.prototype.slice.call(buttonGroup.children).forEach((button) => {
          if (button.innerHTML === parkingType) {
            button.classList.add("btn-active");
          } else {
            button.classList.remove("btn-active");
          }
        });
      }
    }, [parkingType]);

    useEffect(() => {
      if (previousParkingType !== parkingType) {
        setFirstPlace();
        setSecondPlace();
        setPreviousParkingType(parkingType);
      }

      if (previousAction !== action) {
        setFirstPlace();
        setSecondPlace();
        setPreviousAction(action);
      }
    }, [parkingType, action]);

    useEffect(() => {
      const parkingSpaces = document.querySelectorAll(".parking-space");
      Array.from(parkingSpaces).forEach((space) => {
        if (space.innerHTML === firstPlace) {
          space.classList.add("seated");
        } else if (space.innerHTML === secondPlace) {
          space.classList.add("seated");
        }
      });
    }, [firstPlace, secondPlace]);

    const handleCheck = (e) => {
      if (!e.target.classList.contains("seated-db")) {
        if (!firstPlace) {
          setFirstPlace(e.target.innerHTML);
          return;
        }

        let number;
        if (firstPlace.length === 3) {
          number = firstPlace.slice(0, 2);
        }

        if (firstPlace.length === 2) {
          number = firstPlace.slice(0, 1);
        }
        if (
          e.target.innerHTML !== firstPlace &&
          e.target.innerHTML.includes(number)
        ) {
          setSecondPlace(e.target.innerHTML);
        } else if (!e.target.innerHTML.includes(number)) {
          openToast("Please select a place from the same row.");
        }

        if (firstPlace === e.target.innerHTML) {
          setFirstPlace();
        }

        if (secondPlace === e.target.innerHTML) {
          setSecondPlace();
        }
      }
    };

    const getPlaces = async () => {
      const docRef = doc(db, "takenSeatsIN", "0sdzi0dXHrNHAQona5wc");
      const response = await getDoc(docRef);
      const places = document.querySelectorAll(".parking-space");
      places.forEach((place) => {
        response.data().takenSeatsIN.forEach((takenSeat) => {
          if (takenSeat.place === place.innerHTML) {
            place.classList.add("seated-db");
            place.innerHTML = takenSeat.place + " " + takenSeat.containerNumber;
          }
        });
      });
    };

    useEffect(() => {
      getPlaces();
    }, []);

    return (
      <div className="w-full">
        <ButtonGroup id="btn-group" className="w-full">
          <Button className="button" onClick={() => setParkingType("Normal")}>
            Normal
          </Button>
          <Button
            className="button"
            onClick={() => setParkingType("Emergency")}
          >
            Emergency
          </Button>
        </ButtonGroup>
        {parkingType === "Normal" ? (
          <div className="grid-item-mobile">
            <div onClick={handleCheck} className="parking-space free">
              14A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              14B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              13A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              13B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              12A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              12B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              11A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              11B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              10A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              10B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              9A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              9B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              8A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              8B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              7A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              7B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              6A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              6B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              5A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              5B
            </div>
            <div></div>
            <div onClick={handleCheck} className="parking-space free">
              4
            </div>
            <div></div>
            <div onClick={handleCheck} className="parking-space free">
              3
            </div>
            <div></div>
            <div onClick={handleCheck} className="parking-space free">
              2
            </div>
            <div></div>
            <div onClick={handleCheck} className="parking-space free">
              1
            </div>
          </div>
        ) : (
          <div className="grid-item-mobile">
            <div onClick={handleCheck} className="parking-space free">
              35A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              35B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              34A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              34B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              33A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              33B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              32A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              32B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              31A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              31B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              30A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              30B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              29A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              29B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              28A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              28B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              27A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              27B
            </div>
            <div onClick={handleCheck} className="parking-space free">
              26A
            </div>
            <div onClick={handleCheck} className="parking-space free">
              26B
            </div>
          </div>
        )}
        <div className="legend">
          <div className="legend-flex">
            <div className="circle-1"></div>
            <p>empty place</p>
          </div>
          <div className="legend-flex">
            <div className="circle-3"></div>
            <p>selected place</p>
          </div>
          <div className="legend-flex">
            <div className="circle-2"></div>
            <p>occupied place</p>
          </div>
        </div>
      </div>
    );
  };

  const Step3 = () => {
    return (
      <div className="container text-left">
        <div className="mb-3">
          <label htmlFor="formGroupExampleInput" className="form-label">
            Arrival date
          </label>
          <input
            type="datetime-local"
            className="form-control"
            id="formGroupExampleInput"
            placeholder=""
            name="departureDate"
            value={currentDate}
            onChange={(e) => {
              setCurrentDate(e.target.value);
            }}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="registrationNumber" className="form-label">
            Registration number
          </label>
          <input
            type="text"
            className="form-control"
            id="registrationNumber"
            name="registrationNumber"
            ref={registrationNumber}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="firstContainerNumber" className="form-label">
            {action === "arrival"
              ? `Container number - place ${firstPlace}`
              : "First container number"}
          </label>
          <input
            type="text"
            className="form-control"
            id="firstContainerNumber"
            name="firstContainerNumber"
            ref={firstContainerNumber}
            required
          />
        </div>
        {action === "arrival" && secondPlace && (
          <div className="mb-3">
            <label htmlFor="secondContainerNumber" className="form-label">
              Container number - place {secondPlace}
            </label>
            <input
              type="text"
              className="form-control"
              id="secondContainerNumber"
              name="secondContainerNumber"
              ref={secondContainerNumber}
              required
            />
          </div>
        )}
        {action === "departure" && (
          <div className="mb-3">
            <label htmlFor="secondContainerNumber" className="form-label">
              Second container number
            </label>
            <input
              type="text"
              className="form-control"
              id="secondContainerNumber"
              name="secondContainerNumber"
              ref={secondContainerNumber}
              required
            />
          </div>
        )}
      </div>
    );
  };

  const Step4 = () => {
    return (
      <div className="container text-left">
        <History />
      </div>
    );
  };

  const handleReservation = async () => {
    //setComplete(true);
    if (action === "arrival") {
      const docRef = doc(db, "takenSeatsIN", "0sdzi0dXHrNHAQona5wc");
      const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const existing = response.data().takenSeatsIN || [];
      // walidacja konfliktów: czy miejsce jest już zajęte o tej samej godzinie
      if (firstPlace) {
        const conflictFirst = existing.some((obj) => {
          try {
            return obj.place === firstPlace && moment(obj.date).isSame(moment(currentDate), 'hour');
          } catch (e) {
            return false;
          }
        });
        if (conflictFirst) {
          openToast("Selected first place is already reserved for this hour.");
          return;
        }
      }
      if (secondPlace) {
        const conflictSecond = existing.some((obj) => {
          try {
            return obj.place === secondPlace && moment(obj.date).isSame(moment(currentDate), 'hour');
          } catch (e) {
            return false;
          }
        });
        if (conflictSecond) {
          openToast("Selected second place is already reserved for this hour.");
          return;
        }
      }
      const uuid = uuidv4();
      const uuid2 = uuidv4();
      // Build seats array and call cloud function to reserve atomically
      const seats = [];
      if (firstPlace) {
        seats.push({
          status: "Arrival",
          uid: uuid,
          date: currentDate,
          registrationNumber: registrationNumber.current.value,
          place: firstPlace,
          containerNumber: firstContainerNumber.current.value,
        });
      }
      if (secondPlace) {
        seats.push({
          status: "Arrival",
          uid: uuid2,
          date: currentDate,
          registrationNumber: registrationNumber.current.value,
          place: secondPlace,
          containerNumber: secondContainerNumber.current.value,
        });
      }

      try {
        const reserveFn = httpsCallable(functions, "reserveArrival");
        const res = await reserveFn({ seats });
        if (res.data && res.data.success) {
          openToast2("Places have been successfully reserved.");
          setTimeout(() => window.location.reload(), 1000);
        }
      } catch (err) {
        openToast(err?.message || "Reservation failed");
        return;
      }
    } else {
      const docRef = doc(db, "departures", "ZU08SkLpDoB4bV6CxH0v");
      const docRef2 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      if (
        firstContainerNumber.current.value !== "" &&
        secondContainerNumber.current.value !== ""
      ) {
        const array = [];
        const uuid = uuidv4();
        const uuid2 = uuidv4();
        const object = {
          status: "Departure",
          uid: uuid,
          date: currentDate,
          registrationNumber: registrationNumber.current.value,
          containerNumber: firstContainerNumber.current.value,
        };

        const object2 = {
          status: "Departure",
          uid: uuid2,
          date: currentDate,
          registrationNumber: registrationNumber.current.value,
          containerNumber: secondContainerNumber.current.value,
        };

        array.push(object);
        array.push(object2);
        const departures = array.concat(response.data().departures);
        const departuresHistory = array.concat(
          response2.data().departuresHistory
        );
        await setDoc(docRef2, {
          departuresHistory: departuresHistory,
        }).then(async () => {
          await setDoc(docRef, {
            departures: departures,
          }).then(() => {
            openToast2("Places have been successfully reserved.");
            setTimeout(() => window.location.reload(), 1000);
          });
        });
      } else {
        const array = [];
        const uuid = uuidv4();
        const object = {
          status: "Departure",
          uid: uuid,
          date: currentDate,
          registrationNumber: registrationNumber.current.value,
          containerNumber: firstContainerNumber.current.value,
        };

        array.push(object);
        const departures = array.concat(response.data().departures);
        const departuresHistory = array.concat(
          response2.data().departuresHistory
        );
        await setDoc(docRef2, {
          departuresHistory: departuresHistory,
        }).then(async () => {
          await setDoc(docRef, {
            departures: departures,
          }).then(() => {
            openToast2("Places have been successfully reserved.");
            setTimeout(() => window.location.reload(), 1000);
          });
        });
      }
    }
  };

  return (
    <>
      <ToastContainer
        style={{
          width: "80%",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "1rem",
        }}
        autoClose={2000}
      />
      <div className="flex justify-center items-center flex-col w-full">
        <div
          className="flex flex-row"
          style={{ display: "flex", justifyContent: "center", width: "110%" }}
        >
          {steps?.map((step, i) => (
            <div
              key={i}
              className={`step-item ${currentStep === i + 1 && "active"} ${
                (i + 1 < currentStep || complete) && "complete"
              } `}
            >
              <div className="step">
                {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
              </div>
              <p className="text-gray-500">{step}</p>
            </div>
          ))}
        </div>
      </div>
      {currentStep === 1 ? (
        <Step1 />
      ) : action === "arrival" && currentStep === 2 ? (
        <Step2 />
      ) : action === "arrival" && currentStep === 3 ? (
        <Step3 />
      ) : action === "departure" && currentStep === 2 ? (
        <Step3 />
      ) : action === "history" && currentStep === 2 ? (
        <Step4 />
      ) : (
        ""
      )}
      <div
        className="flex flex-row w-full"
        style={
          currentStep !== 1
            ? { justifyContent: "space-between" }
            : { justifyContent: "end" }
        }
      >
        {currentStep !== 1 && (
          <button
            className="btn"
            onClick={() => setCurrentStep((prev) => prev - 1)}
          >
            Back
          </button>
        )}
        {!complete && (
          <button
            className="btn"
            onClick={() => {
              if (action === "history" && currentStep === steps.length) {
                window.location.reload();
              } else {
                currentStep === steps.length
                  ? registrationNumber.current.value === "" ||
                    firstContainerNumber.current.value === ""
                    ? openToast("Please complete all fields.")
                    : handleReservation()
                  : currentStep === 2
                  ? firstPlace === undefined
                    ? openToast("Please select at least one place.")
                    : currentStep === 3
                    ? registrationNumber.current.value === "" &&
                      firstContainerNumber.current.value === "" &&
                      secondContainerNumber.current.value === ""
                      ? openToast("Please complete all fields.")
                      : handleReservation()
                    : setCurrentStep((prev) => prev + 1)
                  : setCurrentStep((prev) => prev + 1);
              }
            }}
          >
            {currentStep === steps.length ? "Finish" : "Next"}
          </button>
        )}
      </div>
    </>
  );
}
